import styled from 'styled-components/macro';
import { COLORS, CHAT_ROOM_TABS_HEIGHT } from 'styleguide';

const ChatRoomsListContainer = styled.div`
  position: relative;
  height: calc(100% - ${CHAT_ROOM_TABS_HEIGHT});
  background-color: ${COLORS.black};
`;

export default ChatRoomsListContainer;
